export const userTypesList = ['Administrator', 'Operations', 'Sales', 'Read Only']

export const salesOrderStatuses = [
  { id: 1, label: 'Paid', priority: 5 },
  { id: 2, label: 'Late', priority: 1 },
  { id: 3, label: 'Shipped', priority: 3 },
  { id: 4, label: 'Invoiced', priority: 4 },
  { id: 5, label: 'Partially Shipped', priority: 2 },
  { id: 6, label: 'Hold', priority: 6 },
  { id: 7, label: 'Processing', priority: 7 },
  { id: 8, label: 'Fully Shipped/Completed', priority: 8 },
  { id: 9, label: 'Fully Invoiced/Closed', priority: 9 },
  { id: 10, label: 'Closed/Completed', priority: 10 },
  { id: 11, label: 'PO Not Found', priority: 1 },
]

export const rmaStatuses = [
  { id: 1, label: 'Initiated' },
  { id: 2, label: 'Waiting on Vendor Response' },
  { id: 3, label: 'Vendor Approved' },
  { id: 4, label: 'Vendor Rejected' },
  { id: 5, label: 'Pending Product Return from Customer' },
  { id: 6, label: 'Replacement Product Ordered' },
  { id: 7, label: 'Credit Issued' },
  { id: 8, label: 'RMA Completed' },
  { id: 9, label: 'Deleted' },
  { id: 10, label: 'Pending Vendor credit' },
]

export const rmaMerchandizeConditions = [
  { id: 1, label: 'Open Original Packaging Included' },
  { id: 2, label: 'Open Original Packaging Excluded' },
  { id: 3, label: 'Unopened' },
  { id: 4, label: 'Other' },
]
